export const valoresExibidosDenominacoes: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorTags: '',
  separadorComponente: '',
  separadorObservacoes: '',

  //Específicos
  tipoProduto: 'Tipo de Produto',
  dcb: 'DCB',
  denominacaoGenerica: 'Denominação Genérica',
  compBasico: 'Comp. Básico',
  compEspecializado: 'Comp. Especializado',
  compEstrategico: 'Comp. Estratégico',
};

export const headersDenominacaoGenerica = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo', width: 10, key: 'tipoProduto' },
  { text: 'DCB', width: 7, key: 'dcb' },
  { text: 'Básico', width: 4, key: 'compBasico' },
  { text: 'Especializado', width: 4, key: 'compEspecializado' },
  { text: 'Estratégico', width: 4, key: 'compEstrategico' },
  { text: 'Denominação Genérica', width: 60, key: 'denominacaoGenerica' },
];

export const fieldObjectDenominacaoGenerica = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
